<rotate-media [media]="currentDisplayMedia"></rotate-media>
